import dayjs from 'dayjs'

export function formatDate(date?: string, locale?: string): string {
  if (!date) {
    return ''
  }
  return dayjs(date)
    .locale(locale || 'en')
    .format('YYYY.MM.DD')
}
